import React from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import AllRoutes from './routers/AllRoutes';

Sentry.init({
  dsn: 'https://6d25478af1aaace698715ac010db7c27@o4510466694447104.ingest.us.sentry.io/4510471101743104',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
  environment: process.env.NODE_ENV,
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<AllRoutes />);
